import { theme } from "../mui-customs/Theme";

const customScrollbarStyle = {
  "&::-webkit-scrollbar": {
    width: "5px",
    borderRadius: "3px",
  },
  "&::-webkit-scrollbar-track": {
    background: theme.whiteBg.WBG3,
    borderRadius: "3px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: theme.brand1[500],
    borderRadius: "3px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: theme.brand1[600],
    borderRadius: "3px",
  },
};

export default customScrollbarStyle;
